var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayertableicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22_copy",
    "data-name": "Group 22 copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #b80718;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 2,
    width: 8,
    height: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7618,333l3-2.631h-2.26V319.635H7621L7618,317l-3,2.632h2.27v10.732H7615Z",
    transform: "translate(-7604 -317)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayertableicon2);
export default __webpack_public_path__ + "static/media/playertable icon-2.8798ecb010c1c7383eeb2adc8c4bbfb6.svg";
export { ForwardRef as ReactComponent };